import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { LoggerService } from 'src/app/common/services/logger.service';

@Component({
  selector: 'app-gamedata-compare-tool',
  templateUrl: './gamedata-compare-tool.component.html',
  styleUrls: ['./gamedata-compare-tool.component.sass'],
})
export class GamedataCompareToolComponent {
  fileA: File | null = null;
  fileB: File | null = null;
  isUploading = false;
  errorMessage: string | null = null;

  constructor(
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private logger: LoggerService,
  ) {}

  onFileAChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    this.fileA = file || null;
    this.errorMessage = null;
  }

  onFileBChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    this.fileB = file || null;
    this.errorMessage = null;
  }

  async submit(): Promise<void> {
    this.errorMessage = null;
    if (!this.fileA || !this.fileB) {
      this.errorMessage = 'Please select both GameData files (.sqlite).';
      return;
    }
    if (!this.fileA.name.toLowerCase().endsWith('.sqlite') && !this.fileA.name.toLowerCase().endsWith('.db')) {
      this.errorMessage = 'File A must be a SQLite file (.sqlite or .db).';
      return;
    }
    if (!this.fileB.name.toLowerCase().endsWith('.sqlite') && !this.fileB.name.toLowerCase().endsWith('.db')) {
      this.errorMessage = 'File B must be a SQLite file (.sqlite or .db).';
      return;
    }

    this.isUploading = true;
    const formData = new FormData();
    formData.append('fileA', this.fileA);
    formData.append('fileB', this.fileB);

    try {
      const res = await this.http
        .post<{ id: number }>('/api/GamedataDiff/compare-upload', formData)
        .toPromise();
      if (res?.id) {
        this.messageService.add({
          severity: 'success',
          summary: 'Comparison complete',
          detail: 'Redirecting to results...',
        });
        this.router.navigate(['/gamedata-diff-v2'], { queryParams: { id: res.id } });
      } else {
        this.errorMessage = 'Invalid response from server.';
      }
    } catch (err: any) {
      this.logger.error('Gamedata compare upload failed', err);
      const msg =
        err?.error?.message ||
        err?.error?.error ||
        (typeof err?.error === 'string' ? err.error : null) ||
        err?.message ||
        'Upload or comparison failed. Check that both files are valid GameData SQLite databases.';
      this.errorMessage = msg;
      this.messageService.add({
        severity: 'error',
        summary: 'Compare failed',
        detail: msg,
      });
    } finally {
      this.isUploading = false;
    }
  }

  clearFiles(): void {
    this.fileA = null;
    this.fileB = null;
    this.errorMessage = null;
    const inputs = document.querySelectorAll('input[type="file"]') as NodeListOf<HTMLInputElement>;
    inputs.forEach((input) => (input.value = ''));
  }
}
